/**
 * Motivos de bloqueio de acesso nesta plataforma.
 *
 * O acesso à área de membros é sempre um espelho da "Gestão de cadastros Beit":
 * quem pede exclusão, é removido de lá ou está com dados obrigatórios
 * incompletos fica bloqueado aqui até a situação ser resolvida na Gestão.
 */

export const ACCESS_BLOCK_REASONS = [
  "dados_incompletos",
  "exclusao_solicitada",
  "cadastro_removido",
  "acesso_revogado",
] as const;

export type AccessBlockReason = (typeof ACCESS_BLOCK_REASONS)[number];

export function isAccessBlockReason(value: unknown): value is AccessBlockReason {
  return typeof value === "string" && (ACCESS_BLOCK_REASONS as readonly string[]).includes(value);
}

/** Rótulo curto usado em listagens administrativas e logs. */
export const ACCESS_BLOCK_LABEL: Record<AccessBlockReason, string> = {
  dados_incompletos: "Dados incompletos",
  exclusao_solicitada: "Exclusão solicitada",
  cadastro_removido: "Cadastro removido",
  acesso_revogado: "Acesso revogado",
};

type BlockCopy = { title: string; description: string };

/** Texto exibido ao membro na tela de acesso bloqueado. */
export function accessBlockCopy(
  reason: string | null | undefined,
  missing: string[] = [],
): BlockCopy {
  const pending = missing
    .map((m) => (m === "full_name" ? "nome completo" : m === "cpf" ? "CPF" : m))
    .join(" e ");

  switch (reason) {
    case "exclusao_solicitada":
      return {
        title: "Exclusão de cadastro solicitada",
        description:
          "Consta na Gestão de cadastros um pedido de exclusão do seu cadastro, por isso o acesso à área de membros está suspenso. Se o pedido foi feito por engano, cancele-o na Gestão de cadastros ou fale com o suporte da congregação.",
      };
    case "cadastro_removido":
      return {
        title: "Cadastro não encontrado na Gestão",
        description:
          "Seu cadastro foi removido ou inativado na Gestão de cadastros da congregação. Enquanto ele não for reativado lá, o acesso à área de membros permanece bloqueado.",
      };
    case "acesso_revogado":
      return {
        title: "Acesso não liberado",
        description:
          "A Gestão de cadastros informa que seu cadastro está sem liberação de acesso. Regularize a situação na Gestão de cadastros e o acesso é restabelecido pela sincronização automática.",
      };
    default:
      return {
        title: "Cadastro incompleto",
        description: `Para acessar a área de membros, os dados obrigatórios${
          pending ? ` (${pending})` : ""
        } precisam estar preenchidos na Gestão de cadastros da congregação. Esses dados não são editáveis aqui: complete-os lá e a sincronização automática atualiza esta plataforma.`,
      };
  }
}
